import { put, call, takeLatest } from "redux-saga/effects";
import { callAPI } from "./commonApiCall";
import apiURLs from "../config/url-config";
import { alertActions, uploadActions } from "../actions";
import { uploadConstants } from "../constants";

function* upload(action) {
  try {

    const data = yield call(callAPI, apiURLs.upload, action.payload,  'POST', true);

    // set data to store on success
    if (data.status === true) {
      yield put(uploadActions.uploadSuccess({
        data: data.data
      }));
    } else {
      //show error message
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
    yield put(alertActions.error("Unable to retirieve settings at the moment."));
  }
}

export function* uploadSaga() {
  yield takeLatest(uploadConstants.UPLOAD_REQUEST, upload);
}
